<h1>{{'educational_history_order' | translate}}</h1>
<form [formGroup]="form">
  <formly-form [model]="model" [fields]="fields" [options]="options" [form]="form"></formly-form>
</form>
<!-- <button type="button" label="click" pButton (click)="submit()"></button> -->
